import { render, staticRenderFns } from "./BodyCellEditor.vue?vue&type=template&id=cb463704&scoped=true"
import script from "./BodyCellEditor.vue?vue&type=script&lang=ts"
export * from "./BodyCellEditor.vue?vue&type=script&lang=ts"
import style0 from "./BodyCellEditor.vue?vue&type=style&index=0&id=cb463704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb463704",
  null
  
)

export default component.exports